<div *ngIf="showLoadingCoupon" class="offer-detail-loading">
    <div class="loading-spinner">
    <div class="large progress" alt="Loading..." ><div class="prog1"><div class="prog2"></div></div></div>
</div>
</div>
<div class="container-fluid" *ngIf="!showLoadingCoupon">
    <div class="row abs-no-gutters">
        <div class="remove-rl-padding col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="breadcrumb section"></div>
            <div class="just-for-you-offer-detail section offer-details-nextgen-container">
                <span class="offer-details-wrapper">
                    <div class="row offer-data">
                        <div class="col-lg-7 col-md-7">
                            <div class="offer-details-heading">
                                <div *ngIf="logoProps && iconImage && iconImage !== ''">
                                    <img src='{{logoProps[iconImage].logo}}'
                                            class="svg-icon just-for-you-16px icon-position" 
                                            alt='{{logoProps[iconImage].altText}}' attr.aria-label='{{logoProps[iconImage].altText}}'>
                                </div>
                                <span id="offerDetailHeadingSavings" class="heading-savings">{{offerDataForOfferDetailsPage.savings}}</span>
                            </div>
                            <span class="offer-details-heading">
                                <span class="heading-offer-price in-store-price"
                                    [ngClass]="{'in-store-price-visible' : offerDataForOfferDetailsPage.regularPrice && offerDataForOfferDetailsPage.regularPrice !== ''}">In-store: ${{offerDataForOfferDetailsPage.regularPrice}}
                                </span>
                            </span>
                            <div class="offer-details-description">
                                <div id="offerDetailTitleId" class="offer-details-title">
                                    {{offerDataForOfferDetailsPage.title}}
                                </div>
                                <div id="offerDetailDescriptionId" class="offer-details-description">
                                    {{offerDataForOfferDetailsPage.description}}
                                </div>
                                <div class="offer-type-details">
                                    <span id="offerDetailCouponTypeId" class="offer-details-coupon-type">
                                        {{couponTypeFull}}:
                                    </span>
                                    <span class="offer-details-offer-type">
                                        {{offerDataForOfferDetailsPage.offerType}}
                                    </span>
                                    <span class="offer-dot">.</span>
                                    <span class="offer-details-end-date">
                                        Expires&nbsp;{{offerDataForOfferDetailsPage.endDate | date: 'MM/dd/yy'}}
                                    </span>
                                </div>
                            </div>
                            <div class="offer-details-clip" aria-live="polite" *ngIf="((offerDataForOfferDetailsPage.offerPgm != 'TR') && (offerDataForOfferDetailsPage.offerPgm != 'GR') && displayClipCouponForPDOffers)">
                                <!-- NEED TO HANDLE CONTINUITY / BEHAVIORAL OFFERS -->
                                <div *ngIf="isBehaviourOrContinuityCoupon">
                                    <app-continuity-offer [showLoadingCoupon]="showSpinner" [couponData]="offerDataForOfferDetailsPage" [isOfferDetailsPage]="true" (startChallengeEvent)="clipCoupon()"></app-continuity-offer>
                                </div>
                                <ng-container *ngIf="offerDataForOfferDetailsPage.status == 'U' && !isBehaviourOrContinuityCoupon">
                                    <button id="offerDetailButton{{offerDataForOfferDetailsPage.offerId}}" [ngClass] = "{'btn':true, 'btn-default':true, 'loading-offer-detail': showSpinner}" (click)="clipCoupon()" [disabled]="showSpinner">
                                        {{offerDataForOfferDetailsPage.deleted ? 'Add to List' : clipCouponLabel}}
                                        <span class="sr-only">{{couponTypeFull + " " + offerDataForOfferDetailsPage.savings + " " + offerDataForOfferDetailsPage.title}}</span>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="offerDataForOfferDetailsPage.status == 'C' && !isBehaviourOrContinuityCoupon">
                                    <div class="coupon-clipped-container" attr.alt="{{offerDataForOfferDetailsPage.savings}}">
                                        <svg width="18px" height="18px" class="svg-icon svg-icon-coupon-carousel-tick-mark" aria-hidden="true" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Symbols" stroke-width="1" fill-rule="evenodd">
                                                <g id="Icons-/-Universal-/-Check-/-Gray" fill="#757575">
                                                    <polygon id="GreenCheck" points="19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236"></polygon>
                                                </g>
                                            </g>
                                        </svg>
                                        <span class="coupon-clipped-txt">{{clippedLabel}}</span>
                                        <span class="sr-only">You clipped this coupon</span>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="offer-details-detail" *ngIf="offerDataForOfferDetailsPage.detail">
                                <span class="text-bold">Offer detail:&nbsp;</span>
                                <span [innerHTML]="offerDataForOfferDetailsPage.detail"></span>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-5">
                            <div class="offer-details-description-image-wrapper">
                                <picture>
                                    <source media="(min-width: {{md}})" srcset="{{getImageUrl('desktop')}}">
                                    <source media="(min-width: {{sm}})" srcset="{{getImageUrl('tablet')}}">
                                    <img loading="lazy" class="offer-details-description-image" alt="presentation" role="presentation" src="{{getImageUrl('mobile')}}" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div class="offer-details-disclaimer">
                        <span class="text-bold">Disclaimer: {{offerDataForOfferDetailsPage.disclaimer}}</span>
                    </div>
                </span>
            </div>
        </div>
    </div>
</div>
